import styles from "./SwapHeader.module.css"
import { MdShowChart } from "react-icons/md"
import { HiDotsHorizontal} from "react-icons/hi"
import { FiSettings} from "react-icons/fi"
import ContentHeader from "../../misc/ContentHeader/ContentHeader"

const SwapHeader = () => {
  return (
      <ContentHeader>

          <span>
          <MdShowChart   />
          </span>
          <span className={styles.title}>Trade</span>
          <div className={styles.settings_container}>
          <HiDotsHorizontal   />
          <FiSettings   />

          
          </div>
      </ContentHeader>
  
  )
}

export default SwapHeader
